import React, { useState, useRef, useEffect } from 'react'
import './Navbar.css'
import logo from '../../assets/Logo-2.jpg'
import {Link} from 'react-router-dom'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Mobile from './Mobile';
library.add(fas)


const Navbar = () => {
  
  return (
    <div id="header" class="header d-flex align-items-center ">
        <div class="container-fluid container-xl position-relative d-flex align-items-center">
        <a href="https://www.takshilavlsi.com/" class="logo d-flex align-items-center me-auto">
        <img src={logo} alt="" />
      </a>
      

      <nav id="navmenu" class="navmenu" expand="lg">
        <ul>
          <li class="dropdown"><a href="#"><span>Takshila VLSI</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
            <ul>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Vision</a></li>
              <li><a href="#">Why Join Us</a></li>
              <li><a href='#' target='_blank'>Blog</a></li>
              <li><a href="#">Apply as Trainer</a></li>
            </ul>
          </li>
          <li class="dropdown"><a href="#"><span>Courses</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
            <ul>
             
              <li class="dropdown"><a href="#"><span>For Freshers</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                <li><a href="#">Physical Design</a></li>
                <li><a href="#">ASIC Verification</a></li>
                <li><a href="#">Analog Layout Design</a></li>
                <li><a href="#">Design For Test</a></li>
                <li><a href="#">Analog Circuit Design</a></li>
                <li><a href="#">RTL Coding and FPGA Design</a></li>
                <li><a href="#">Embedded Systems Training</a></li>
                </ul>
              </li>
              <li class="dropdown"><a href="#"><span>For Working Professionals</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                <li><a href="#">Physical Design-Part Time</a></li>
                <li><a href="#">ASIC Verification-Part Time</a></li>
                <li><a href="#">Analog Layout Design-Part Time</a></li>
                <li><a href="#">Design For Test-Part Time</a></li>
                <li><a href="#">Analog Circuit Design</a></li>
                <li><a href="#">RTL Coding and FPGA Design-Part Time</a></li>
                <li><a href="#">FINFET Layout Design Training</a></li>
                <li><a href="#">UVM Training</a></li>
                <li><a href="#">PERL Scripting</a></li>
                </ul>
              </li>
              <li class="dropdown"><a href="#"><span>Online Courses</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                <li><a href="#">Physical Design Online</a></li>
                <li><a href="#">ASIC Verification Online</a></li>
                <li><a href="#">Analog Layout Design Online</a></li>
                <li><a href="#">Design For Test Online</a></li>
                <li><a href="#">Analog Circuit Design Online</a></li>
                <li><a href="#">RTL Coding and FPGA Design Online</a></li>
                <li><a href="#">UVM Training Online</a></li>
                </ul>
              </li>
              <li><a href="#">Online Course Videos</a></li>
              <li><a href="#">Free Demo Class</a></li>
              <li><a href="#">1-Day Free VLSI Training</a></li>
               
            </ul>
          </li>
          <li><a href="#">Course Calendar</a></li>
          <li class="dropdown"><a href="#"><span>Corporate</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
            <ul>
              <li><a href="#">Academic</a></li>
              
            </ul>
          </li>
          <li><a href="#">Placements</a></li>
          <li><a href="#">Contact</a></li>
          <li><a href="#">Blog</a></li>
        </ul>

        {/*<i class="mobile-nav-toggle d-xl-none bi bi-list" aria-controls="navmenu"></i>*/}
       

    </nav>
    <Mobile/>
    

    
      <Link class="btn-getstarted">Get Demo Class <FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></Link>
        </div> 
        
  </div>
    
  )
}

export default Navbar